import { ArrowRightAlt } from "@ellaandil/ui";
import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Asset } from "@/components/ui/Asset";
import { Typography } from "@/components/ui/Typography";
import type { PageHeaderCollectionStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import { sbLink } from "@/lib/storyblok/link";

export const PageHeaderCollectionBlok = ({ blok }: BlokProps<PageHeaderCollectionStoryblok>) => {
	const href = sbLink(blok.link)?.href;
	return (
		<BlokWrap editable={blok} asChild>
			<Link
				href={href || "#"}
				className="relative flex shrink-0 aspect-3/4 w-[300px] bg-background-bg-image lg:w-[calc(25%-6px)]"
			>
				<Asset
					className="pointer-events-none absolute inset-0 size-full object-cover"
					asset={blok.image}
				/>
				<div className="absolute inset-0 bg-overlay-2" />
				<div className="absolute inset-0 flex flex-col items-start justify-between p-grid-component-spacing-md">
					{blok.caption && (
						<Typography variant="label-md-reg" className="w-full text-text-sand-text-2">
							{blok.caption}
						</Typography>
					)}
					<Typography variant="heading-lg" className="w-full text-text-sand-text-2 leading-[1.25]">
						{blok.title}
					</Typography>
					<div className="flex w-full items-center gap-grid-component-spacing-4xs">
						<Typography
							variant="label-md-reg"
							className="min-w-px flex-[1_0_0] text-text-sand-text-2"
						>
							{blok.actionLabel ?? "Explore"}
						</Typography>
						<ArrowRightAlt className="size-6 text-text-sand-text-2" />
					</div>
				</div>
			</Link>
		</BlokWrap>
	);
};
